module.exports = __webpack_public_path__ + "static/media/yoyo.53702e99.jpg";